/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const PP_PREFIX = 'ACTIVITYPASS_';

// --- Facilities
export const FETCH_FACILITIES = `${PP_PREFIX}FETCH_FACILITIES`;
export const RESET_FACILITIES = `${PP_PREFIX}RESET_FACILITIES`;

// --- Pass Types
export const FETCH_PASS_TYPES = `${PP_PREFIX}FETCH_PASS_TYPES`;
export const RESET_PASS_TYPES = `${PP_PREFIX}RESET_PASS_TYPES`;

export const FETCH_PASS_TYPE = `${PP_PREFIX}FETCH_PASS_TYPE`;
export const RESET_PASS_TYPE = `${PP_PREFIX}RESET_PASS_TYPE`;

// --- Reservations
export const FETCH_RESERVATIONS = `${PP_PREFIX}FETCH_RESERVATIONS`;
export const CREATE_RESERVATIONS = `${PP_PREFIX}CREATE_RESERVATIONS`;
export const UPDATE_RESERVATION = `${PP_PREFIX}UPDATE_RESERVATION`;
export const DELETE_RESERVATION = `${PP_PREFIX}DELETE_RESERVATION`;
export const RESET_RESERVATIONS = `${PP_PREFIX}RESET_RESERVATIONS`;

export const VALIDATE_RESERVATIONS = `${PP_PREFIX}VALIDATE_RESERVATIONS`;
export const VALIDATE_RESERVATIONS_CLEAR = `${PP_PREFIX}VALIDATE_RESERVATIONS_CLEAR`;

// Cart/Account/Other
export const FETCH_FACILITY = `${PP_PREFIX}FETCH_FACILITY`;
export const FETCH_FACILITY_BY_ID_OR_SLUG = `${PP_PREFIX}FETCH_FACILITY_BY_ID_OR_SLUG`;

// --- Address
export const VERIFY_ADDRESS = `${PP_PREFIX}VERIFY_ADDRESS`;
